import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Eye, ArrowLeft } from "lucide-react";

const ROLE_LABEL = { tenant_admin: "Company Admin", learner: "Learner" };

export default function PreviewBanner() {
  const { previewInfo, stopPreview } = useAuth();
  const navigate = useNavigate();

  if (!previewInfo) return null;

  const exit = async () => {
    await stopPreview();
    navigate("/admin/tenants");
  };

  return (
    <div
      data-testid="preview-banner"
      className="sticky top-0 z-50 flex items-center justify-between gap-3 bg-[#0A0A0A] px-4 py-2 text-white"
    >
      <div className="flex items-center gap-2 text-sm">
        <Eye className="h-4 w-4 text-amber-400" />
        <span>
          Viewing as <span className="font-semibold">{ROLE_LABEL[previewInfo.role] || previewInfo.role}</span>
          {previewInfo.tenantName ? <span className="text-white/70"> · {previewInfo.tenantName}</span> : null}
        </span>
      </div>
      <button
        data-testid="preview-exit-button"
        onClick={exit}
        className="flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-xs font-semibold text-[#0A0A0A] transition-colors hover:bg-white/90"
      >
        <ArrowLeft className="h-3.5 w-3.5" /> Return to Admin View
      </button>
    </div>
  );
}
